import { ServicioRaw, Servicio } from "./types/servicio";
import { fetchWithRetry } from "../client";
import { cmsLang, type Locale } from "@/i18n/config";

export async function fetchServicios(lang: Locale): Promise<Servicio[]> {
  const res = await fetchWithRetry<{ data: ServicioRaw[] }>(
    `/servicios?lang=${cmsLang(lang)}`
  );

  return res.data.map(
    (item): Servicio => ({
      id: item.id,
      nombre: item.nombre,
      descripcion: item.descripcion,
      imagen: item.foto,
      ubicacion: item.ubicacion,
      contacto: item.contacto,
      horario: item.horario,
    })
  );
}
